module.exports = __webpack_public_path__ + "img/balloon.f49875ac.png";